module.exports = __webpack_public_path__ + "img/fixmix.839c20cc.png";